'use client';

import { type MsalAuthenticationProps } from '@azure/msal-react';

import SplashScreen from '@/components/splashScreen/SplashScreen';

export const Loading: MsalAuthenticationProps['loadingComponent'] = ({}) => {
  return <SplashScreen />;
};
